<template>
  <a-form :form="form" @submit="submit" class="orderForm manufacturerForm">
    <a-form-item
      v-bind="formItemLayout"
      v-for="(item,index) in orderParams "
      :key="index"
      :label="item.label"
      :class="/(is\_xcx|is\_wechat\_payment)/.test(item.key)?'radio_item':''"
    >
      <!-- 单选切换按钮 -->
      <div v-if="item.key == 'is_xcx'">
        <a-radio-group
          :disabled="complete"
          v-decorator="[item.key,{ rules: [ {required: !cacheCilent, message: '请选择'+item.label}],initialValue:item.value}]"
          @change="hasXcx"
        >
          <a-radio :value="1">已有认证公众号账号</a-radio>
          <a-radio :value="0">没有认证公众号账号</a-radio>
        </a-radio-group>
      </div>
      <div v-else-if="item.key == 'is_wechat_payment'">
        <a-radio-group
          :disabled="complete"
          v-decorator="[item.key,{ rules: [ {required: !cacheCilent, message: '请选择'+item.label}],initialValue:item.value}]"
          @change="hasPay"
        >
          <a-radio :value="1">是</a-radio>
          <a-radio :value="0">否</a-radio>
        </a-radio-group>
      </div>
      <!-- 必填input -->
      <div v-else-if="/(mp\_account|phone|email|xcx\_name|mobile)/.test(item.key)">
        <a-input
          class="orderInput"
          :disabled="complete"
          type="text"
          autocomplete="off"
          v-decorator="[item.key, { rules: [ {required: !cacheCilent, message: '请填写'+item.label}]}]"
        />
      </div>
      <div v-else-if="item.key == 'mp_password'">
        <input style="display:none">
        <a-input
          class="orderInput"
          :disabled="complete"
          :type="item.key == 'mp_password'?'password':'text'"
          autocomplete="new-password"
          v-decorator="[item.key, { rules: [ {required: !cacheCilent, message: '请填写'+item.label}]}]"
        />
      </div>
      <div v-else-if="/(wechat_number)/.test(item.key)">
        <a-input class="orderInput" v-decorator="[item.key]"/>
      </div>
      <!-- 图片上传 -->
      <div v-else-if="item.key=='bizlicense'">
        <div class="complete-image" v-if="complete">
          <div class="complete-image-box" v-for="(image,index) in item.value" :key="index">
            <img :src="image.url" alt>
          </div>
        </div>
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          v-else
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          :disabled="complete"
          @preview="handlePreview"
          @change="imgChange_bizlicense"
          v-decorator="[item.key, { rules: [ {required: !cacheCilent, message: '请上传'+item.label}]}]"
        >
          <div v-if="item.value.length < 10">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">
          1.请上传最新的有效期内的证件，要求清晰，无污染，完整的证件照片
          <br>2.若非三证合一，请在此处上传营业执照，组织机构代码以及税务登记证（认证费开票使用）
          <br>3.格式要求：原件照片，扫描件或者加盖公章的复印件
        </div>
      </div>
      <div v-else-if="item.key=='opening_permit'">
        <div class="complete-image" v-if="complete">
          <div class="complete-image-box" v-for="(image,index) in item.value" :key="index">
            <img :src="image.url" alt>
          </div>
        </div>
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          v-else
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          :disabled="complete"
          @preview="handlePreview"
          @change="imgChange_opening_permit"
          v-decorator="[item.key, { rules: [ {required: !cacheCilent, message: '请上传'+item.label}]}]"
        >
          <div v-if="item.value.length < 1">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">
          1.请上传最新的有效期内的证件，要求清晰，无污染，完整的证件照片
          <br>2.格式要求：原件照片，扫描件或者加盖公章的复印件
          <br>3.个体户请把法人银行卡开户名称，开户地址，银行卡号拍照上传
        </div>
      </div>
      <!-- 身份证正面 -->
      <div v-else-if="item.key=='idcard0_ocr_data'">
        <div class="complete-image" v-if="complete">
          <div class="complete-image-box" v-for="(image,index) in item.value" :key="index">
            <img :src="image.url" alt>
          </div>
        </div>
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          v-else
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          :disabled="complete"
          @preview="handlePreview"
          @change="imgChange_idcard0_ocr_data"
          v-decorator="[item.key, { rules: [ {required: !cacheCilent, message: '请上传'+item.label}]}]"
        >
          <div v-if="item.value.length < 1">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">
          1.请上传最新的有效期内的证件，要求清晰，无污染，完整的证件照片
          <br>2.格式要求：原件照片或者扫描件
          <br>3.个体工商户请上传法人身份证正面
        </div>
      </div>
      <!-- 身份证反面 -->
      <div v-else-if="item.key=='idcard1_ocr_data'">
        <div class="complete-image" v-if="complete">
          <div class="complete-image-box" v-for="(image,index) in item.value" :key="index">
            <img :src="image.url" alt>
          </div>
        </div>
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          v-else
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          :disabled="complete"
          @preview="handlePreview"
          @change="imgChange_idcard1_ocr_data"
          v-decorator="[item.key, { rules: [ {required: !cacheCilent, message: '请上传'+item.label}]}]"
        >
          <div v-if="item.value.length < 1">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">
          1.请上传最新的有效期内的证件，要求清晰，无污染，完整的证件照片
          <br>2.格式要求：原件照片或者扫描件
          <br>3.个体工商户请上传法人身份证反面
        </div>
      </div>
      <!-- 运营者身份证正面 -->
      <div v-else-if="item.key=='idcard_0'">
        <div class="complete-image" v-if="complete">
          <div class="complete-image-box" v-for="(image,index) in item.value" :key="index">
            <img :src="image.url" alt>
          </div>
        </div>
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          v-else
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          :disabled="complete"
          @preview="handlePreview"
          @change="imgChange_idcard_0"
          v-decorator="[item.key, { rules: [ {required: !cacheCilent, message: '请上传'+item.label}]}]"
        >
          <div v-if="item.value.length < 1">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">
          1.请上传最新的有效期内的证件，要求清晰，无污染，完整的证件照片
          <br>2.格式要求：原件照片或者扫描件
          <br>3.个体工商户请上传法人身份证正面
        </div>
      </div>
      <!-- 运营者身份证反面 -->
      <div v-else-if="item.key=='idcard_1'">
        <div class="complete-image" v-if="complete">
          <div class="complete-image-box" v-for="(image,index) in item.value" :key="index">
            <img :src="image.url" alt>
          </div>
        </div>
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          v-else
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          :disabled="complete"
          @preview="handlePreview"
          @change="imgChange_idcard_1"
          v-decorator="[item.key, { rules: [ {required: !cacheCilent, message: '请上传'+item.label}]}]"
        >
          <div v-if="item.value.length < 1">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">
          1.请上传最新的有效期内的证件，要求清晰，无污染，完整的证件照片
          <br>2.格式要求：原件照片或者扫描件
          <br>3.个体工商户请上传法人身份证反面
        </div>
      </div>
      <!-- 行业资质 -->
      <div v-else-if="item.key=='qualification'">
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          @preview="handlePreview"
          @change="imgChange_qualification"
          v-decorator="[item.key]"
        >
          <div v-if="item.value.length < 10">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">
          1.请上传最新的有效期内的证件，要求清晰，无污染，完整的证件照片
          <br>2.格式要求：原件照片，扫描件或者加盖公章的复印件
          <br>3.需要特殊资质的商户上传，最多上传10张
        </div>
      </div>
      <!-- 其它资料 -->
      <div v-else-if="item.key=='other_materials'">
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          @preview="handlePreview"
          @change="imgChange_other_materials"
          v-decorator="[item.key]"
        >
          <div v-if="item.value.length < 10">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">商标证书等其他资料上传此处，最多上传10张</div>
      </div>
      <!-- 小程序头像 -->
      <div v-else-if="item.key=='xcx_avatar'">
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          @preview="handlePreview"
          @change="imgChange_xcx_avatar"
          v-decorator="[item.key]"
        >
          <div v-if="item.value.length < 1">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">建议为公司LOGO，若无暂时不用上传</div>
      </div>
      <!-- 底部固定选填项 -->
      <div v-else-if="item.key=='xcx_banner'">
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          @preview="handlePreview"
          @change="imgChange_xcx_banner"
          v-decorator="[item.key]"
        >
          <div v-if="item.value.length < 1">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">小程序banner图，建议尺寸：750*360，若无暂时不用上传</div>
      </div>
      <div v-else-if="item.key=='wx_qrcode'">
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          @preview="handlePreview"
          @change="imgChange_wx_qrcode"
          v-decorator="[item.key]"
        >
          <div v-if="item.value.length < 1">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">客户个人微信二维码，建议尺寸：400*400，若无暂时不用上传</div>
      </div>
      <div v-else-if="item.key=='product_data'">
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          @preview="handlePreview"
          @change="imgChange_product_data"
          v-decorator="[item.key]"
        >
          <div v-if="item.value.length < 10">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">最多上传10张</div>
      </div>
      <div v-else-if="item.key=='xcx_template'">
        <a-upload
          class="uploadItem"
          :beforeUpload="beforeUpload"
          accept=".png, .jpg, .jpeg"
          action="/api/workOrder/uploadImg"
          listType="picture-card"
          :fileList="item.value"
          @preview="handlePreview"
          @change="imgChange_xcx_template"
          v-decorator="[item.key]"
        >
          <div v-if="item.value.length < 1">
            <a-icon class="uploadplus" type="plus"/>
          </div>
        </a-upload>
        <div class="enter-tip">小程序意向模板图</div>
      </div>
    </a-form-item>
    <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage">
    </a-modal>
    <a-form-item :wrapper-col="{ span: 12, offset: 6 }">
      <a-button class="submit-btn" type="primary" html-type="submit">提交审核</a-button>
      <a-button
        v-if="!complete"
        class="temporary-btn"
        ghost
        data-cache="true"
        type="primary"
        @click="cacheCilentClick"
      >暂存</a-button>
    </a-form-item>
  </a-form>
</template>


<script>
let orderParams = [
  {
    label: "公众号",
    key: "is_xcx",
    value: 1 // 是否已有公众号： 1： 有， 0： 没有
  },
  //共同部分
  {
    label: "小程序横幅",
    key: "xcx_banner",
    value: []
  },
  {
    label: "微信二维码",
    key: "wx_qrcode",
    value: []
  },
  {
    label: "产品资料",
    key: "product_data",
    value: []
  },
  {
    label: "意向模板",
    key: "xcx_template",
    value: []
  }
];
let is_xcx_1 = [
  // 1 有公众号
  {
    label: "公众号账号",
    key: "mp_account",
    value: ""
  },
  {
    label: "公众号密码",
    key: "mp_password",
    value: ""
  },
  {
    label: "是否开通微信支付",
    key: "is_wechat_payment",
    value: 1 // 是否开通微信支付 1 开通 0未开通
  }
];
let is_wechat_payment_2 = [
  {
    label: "联系电话",
    key: "phone",
    value: ""
  },
  {
    label: "联系邮箱",
    key: "email",
    value: ""
  },
  {
    label: "营业执照",
    key: "bizlicense",
    value: []
  },
  {
    label: "开户许可证",
    key: "opening_permit",
    value: []
  },
  {
    label: "身份证正面",
    key: "idcard0_ocr_data",
    value: []
  },
  {
    label: "身份证反面",
    key: "idcard1_ocr_data",
    value: []
  },
  {
    label: "行业资质",
    key: "qualification",
    value: []
  }
];
let is_xcx_2 = [
  // 0 没有公众号
  {
    label: "小程序名称",
    key: "xcx_name",
    value: ""
  },
  {
    label: "运营者手机号",
    key: "mobile",
    value: ""
  },
  {
    label: "运营者微信号",
    key: "wechat_number",
    value: ""
  },
  {
    label: "营业执照",
    key: "bizlicense",
    value: []
  },
  {
    label: "开户许可证",
    key: "opening_permit",
    value: []
  },
  {
    label: "运营者身份证正面",
    key: "idcard_0",
    value: []
  },
  {
    label: "运营者身份证反面",
    key: "idcard_1",
    value: []
  },
  {
    label: "行业资质",
    key: "qualification",
    value: []
  },
  {
    label: "其他材料",
    key: "other_materials",
    value: []
  },
  {
    label: "小程序头像",
    key: "xcx_avatar",
    value: []
  }
];
const formItemLayout = {
  labelCol: {
    xs: { span: 6 },
    sm: { span: 6 }
  },
  wrapperCol: {
    xs: { span: 18 },
    sm: { span: 18 }
  }
};
const tailFormItemLayout = {
  wrapperCol: {
    xs: {
      span: 24,
      offset: 0
    },
    sm: {
      span: 16,
      offset: 8
    }
  }
};
export default {
  props: ["complete", "order_id"],
  data() {
    return {
      formItemLayout,
      tailFormItemLayout,
      orderParams: JSON.parse(JSON.stringify(orderParams)),
      previewVisible: false,
      previewImage: "",
      hasSubmit: false,
      cacheCilent: false,
      imgUid: -1,
      cacheIs_xcx: "",
      cacheIs_wechat_payment: ""
    };
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
  },
  created() {
    this.resetForm();
    this.getOrderInfo();
  },
  mounted() {},
  methods: {
    //提交
    submit(e) {
      e.preventDefault();
      if (this.hasSubmit) return;
      this.orderParams.map((v, k) => {
        if (
          /(is\_xcx|is\_wechat\_payment|wechat\_number|mp\_account|mp\_password|phone|email|xcx\_name|mobile)/.test(
            v.key
          )
        )
          return;
        this.imgDataTreat(v);
      });

      let flag = true;
      let data = "";
      //必填项校验
      this.form.validateFieldsAndScroll(
        {
          scroll: {
            onlyScrollIfNeeded: true,
            offsetTop: 120
          }
        },
        (err, values) => {
          data = values;
          if (!err) {
            flag = false;
          }
        }
      );
      if (flag && !this.cacheCilent) {
        return;
      }
      // 厂商注册
      data.client_data_type = 2;
      let url = this.cacheCilent
        ? "/api/WorkOrder/CacheCilent"
        : this.complete
        ? "/api/WorkOrder/EditCilent"
        : "/api/WorkOrder/clientCreate";

      data.order_id = this.order_id;
      axios({
        url: url,
        method: "POST",
        data: data
      })
        .then(res => {
          if (res.data.status == 0) {
            this.$router.push(`/myOrder`);
          }
          this.hasSubmit = false;
          this.cacheCilent = false;
        })
        .catch(err => {
          this.hasSubmit = false;
          this.cacheCilent = false;
        });
    },
    //暫存
    cacheCilentClick() {
      this.cacheCilent = true;
      document.querySelector(".manufacturerForm .submit-btn").click();
    },
    //图片上传
    beforeUpload(file) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      return flag;
    },
    handleCancel() {
      this.previewVisible = false;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    imgChange_bizlicense({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      let index = this.orderParams[0].value ? 6 : 4;
      this.orderParams[index].value = fileList;
    },
    imgChange_opening_permit({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      let index = this.orderParams[0].value ? 7 : 5;
      this.orderParams[index].value = fileList;
    },
    imgChange_idcard_0({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      let index = 6;
      this.orderParams[index].value = fileList;
    },
    imgChange_idcard_1({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      let index = 7;
      this.orderParams[index].value = fileList;
    },
    imgChange_idcard0_ocr_data({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      let index = 8;
      this.orderParams[index].value = fileList;
    },
    imgChange_idcard1_ocr_data({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      let index = 9;
      this.orderParams[index].value = fileList;
    },
    imgChange_qualification({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      let index = this.orderParams[0].value ? 10 : 8;
      this.orderParams[index].value = fileList;
    },
    imgChange_other_materials({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      let index = 9;
      this.orderParams[index].value = fileList;
    },
    imgChange_xcx_avatar({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      let index = 10;
      this.orderParams[index].value = fileList;
    },
    imgChange_xcx_banner({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      this.orderParams[this.orderParams.length - 4].value = fileList;
    },
    imgChange_wx_qrcode({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      this.orderParams[this.orderParams.length - 3].value = fileList;
    },
    imgChange_product_data({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      this.orderParams[this.orderParams.length - 2].value = fileList;
    },
    imgChange_xcx_template({ file, fileList }) {
      let flag = /^(.*)\.(png|jpg|jpeg)$/.test(file.name);
      if (!flag) {
        this.$message.error("请上传png，jpg，jpeg格式的文件");
        return;
      }
      this.orderParams[this.orderParams.length - 1].value = fileList;
    },
    //处理图片数据
    imgDataTreat(imgData = {}) {
      let treatValue = imgData.value.map((v, k) => {
        return v.response ? v.response.data : v.url;
      });
      let params = {};
      params[
        imgData.key
      ] = /(product_data|bizlicense|qualification|other_materials)/.test(
        imgData.key
      )
        ? treatValue
        : treatValue[0] || "";
      this.form.setFieldsValue(params);
    },
    //还原图片数据
    resetImgData(imgData = {}) {
      if (!imgData.urls) {
        this.orderParams[imgData.key].value = [];
        return;
      }
      var fileList = [];
      if (imgData.urls.indexOf("[") + 1) {
        JSON.parse(imgData.urls).map((v, k) => {
          fileList.push({
            uid: this.imgUid--,
            url: v,
            name: `img${this.imgUid}.png`
          });
        });
      } else {
        fileList.push({
          uid: "" + this.imgUid--,
          url: imgData.urls,
          name: `img${this.imgUid}.png`
        });
      }
      this.orderParams[imgData.key].value = fileList;
    },
    //完善资料 获取原数据
    getOrderInfo(change) {
      let url = this.complete
        ? "/api/WorkOrder/OrderDetail"
        : "/api/WorkOrder/OrderDetailCache";
      axios({
        url: url,
        method: "POST",
        data: {
          order_id: this.order_id
        }
      }).then(res => {
        let data = res.data.data;
        let is_xcx = +data.is_xcx;
        let is_wechat_payment = +data.is_wechat_payment;
        this.cacheIs_xcx = is_xcx;
        this.cacheIs_wechat_payment = is_wechat_payment;
        if (is_xcx != 0 && !is_xcx) {
          this.initForm();
          return;
        }
        if (!change) {
          this.orderParams[0].value = is_xcx;
          if (is_xcx == 1) {
            is_xcx_1[2].value = is_wechat_payment;
          }
          this.initForm();
        }else{
          is_wechat_payment = 1;
        }
        this.$nextTick(() => {
          let params = {};
          if (is_xcx == 1) {
            params.mp_account = data.mp_account || "";
            params.mp_password = data.mp_password || "";
            // this.orderParams [2].value = is_wechat_payment;
            if (is_wechat_payment == 0) {
              params.phone = data.phone;
              params.email = data.email;

              this.resetImgData({
                key: 6,
                urls: data.bizlicense
              });

              this.resetImgData({
                key: 7,
                urls: data.opening_permit
              });
              this.resetImgData({
                key: 8,
                urls: data.idcard0_ocr_data
              });
              this.resetImgData({
                key: 9,
                urls: data.idcard1_ocr_data
              });
              this.resetImgData({
                key: 10,
                urls: data.qualification
              });
            }
          } else {
            params.xcx_name = data.xcx_name || "";
            params.mobile = data.mobile || "";
            params.wechat_number = data.wechat_number || "";
            this.resetImgData({
              key: 4,
              urls: data.bizlicense
            });
            this.resetImgData({
              key: 5,
              urls: data.opening_permit
            });
            this.resetImgData({
              key: 6,
              urls: data.idcard_0
            });
            this.resetImgData({
              key: 7,
              urls: data.idcard_1
            });
            this.resetImgData({
              key: 8,
              urls: data.qualification
            });
            this.resetImgData({
              key: 9,
              urls: data.other_materials
            });
            this.resetImgData({
              key: 10,
              urls: data.xcx_avatar
            });
          }
          this.form.setFieldsValue(params);

          this.resetImgData({
            key: this.orderParams.length - 4,
            urls: data.xcx_banner
          });
          this.resetImgData({
            key: this.orderParams.length - 3,
            urls: data.wx_qrcode
          });
          this.resetImgData({
            key: this.orderParams.length - 2,
            urls: data.product_data
          });
          this.resetImgData({
            key: this.orderParams.length - 1,
            urls: data.xcx_template
          });
        });
      });
    },
    //是否认证公众号
    hasXcx(e) {
      let val = e.target.value;
      let oldVal = this.orderParams[0].value;
      if (val != oldVal) {
        this.orderParams[0].value = val;
        if (val) {
          is_xcx_1[2].value = 1;
          this.orderParams.splice(1, is_xcx_2.length, ...is_xcx_1);
        } else {
          let length = this.orderParams[3].value
            ? is_xcx_1.length
            : is_xcx_1.length + is_wechat_payment_2.length;
          this.orderParams.splice(1, length, ...is_xcx_2);
        }
      }
      if (val == this.cacheIs_xcx) {
        this.getOrderInfo(true);
      }
    },
    //是否有支付
    hasPay(e) {
      let val = e.target.value;
      let oldVal = this.orderParams[3].value;
      if (val != oldVal) {
        this.orderParams[3].value = val;
        if (!val) {
          this.orderParams.splice(4, 0, ...is_wechat_payment_2);
        } else {
          this.orderParams.splice(4, is_wechat_payment_2.length);
        }
      }
      if (this.cacheIs_xcx == 1 && val == this.cacheIs_wechat_payment) {
        this.getOrderInfo(true);
      }
    },
    //重置表单数据
    resetForm() {
      orderParams = [
        {
          label: "公众号",
          key: "is_xcx",
          value: 1 // 是否已有公众号： 1： 有， 0： 没有
        },
        //共同部分
        {
          label: "小程序横幅",
          key: "xcx_banner",
          value: []
        },
        {
          label: "微信二维码",
          key: "wx_qrcode",
          value: []
        },
        {
          label: "产品资料",
          key: "product_data",
          value: []
        },
        {
          label: "意向模板",
          key: "xcx_template",
          value: []
        }
      ];
      is_xcx_1 = [
        // 1 有公众号
        {
          label: "公众号账号",
          key: "mp_account",
          value: ""
        },
        {
          label: "公众号密码",
          key: "mp_password",
          value: ""
        },
        {
          label: "是否开通微信支付",
          key: "is_wechat_payment",
          value: 1 // 是否开通微信支付 1 开通 0未开通
        }
      ];
      is_wechat_payment_2 = [
        {
          label: "联系电话",
          key: "phone",
          value: ""
        },
        {
          label: "联系邮箱",
          key: "email",
          value: ""
        },
        {
          label: "营业执照",
          key: "bizlicense",
          value: []
        },
        {
          label: "开户许可证",
          key: "opening_permit",
          value: []
        },
        {
          label: "身份证正面",
          key: "idcard0_ocr_data",
          value: []
        },
        {
          label: "身份证反面",
          key: "idcard1_ocr_data",
          value: []
        },
        {
          label: "行业资质",
          key: "qualification",
          value: []
        }
      ];
      is_xcx_2 = [
        // 0 没有公众号
        {
          label: "小程序名称",
          key: "xcx_name",
          value: ""
        },
        {
          label: "运营者手机号",
          key: "mobile",
          value: ""
        },
        {
          label: "运营者微信号",
          key: "wechat_number",
          value: ""
        },
        {
          label: "营业执照",
          key: "bizlicense",
          value: []
        },
        {
          label: "开户许可证",
          key: "opening_permit",
          value: []
        },
        {
          label: "运营者身份证正面",
          key: "idcard_0",
          value: []
        },
        {
          label: "运营者身份证反面",
          key: "idcard_1",
          value: []
        },
        {
          label: "行业资质",
          key: "qualification",
          value: []
        },
        {
          label: "其他材料",
          key: "other_materials",
          value: []
        },
        {
          label: "小程序头像",
          key: "xcx_avatar",
          value: []
        }
      ];
    },
    initForm() {
      if (this.orderParams[0].value == 1) {
        this.orderParams.splice(1, 0, ...is_xcx_1);
        if (this.orderParams[3].value == 0) {
          this.orderParams.splice(4, 0, ...is_wechat_payment_2);
        }
      } else {
        this.orderParams.splice(1, 0, ...is_xcx_2);
      }
    }
  }
};
</script>
<style scoped>
.orderForm {
  width: 675px;
}
.orderForm .orderInput {
  width: 330px;
  height: 40px;
  border-color: #dcdfe6;
}
.orderForm > .ant-form-item {
  margin-bottom: 20px;
}
.orderForm > .radio_item {
  margin-bottom: 0;
  position: relative;
  top: -10px;
}
.submit-btn,
.temporary-btn {
  border-radius: 16px;
}
.temporary-btn {
  margin-left: 20px;
}
.uploadplus {
  font-size: 30px;
  color: #cfcdcd;
}
.uploadItem .ant-upload-select-picture-card {
  background: #f8f9fb;
}
.complete-image {
  display: flex;
}
.complete-image > .complete-image-box {
  display: inline-block;
  width: 104px;
  height: 104px;
  padding: 8px;
  margin: 0 8px 8px 0;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  overflow: hidden;
}
.complete-image-box > img {
  width: 100%;
}
.enter-tip {
  width: 100%;
  color: #9fa5bb;
  font-size: 14px;
  display: flex;
  /* height: 1em; */
  line-height: 1.1em;
}
.uploadItem >>> .ant-upload-list {
  float: none;
}
.orderForm >>> .ant-form-item-required::before {
  content: "·";
  color: #ff7200;
  font-size: 18px;
}
.orderForm >>> .ant-form-item-required::after,
.orderForm >>> .ant-form-item-label label::after {
  margin-right: 20px;
}
</style>
